// Sdílené utility pro práci s obrázky před uploadem.

/**
 * Zmenší fotku před uploadem (max rozměr + JPEG kvalita), ať se vejde pod PHP limit
 * a šetří data. 2560 px = strop vysokorozlišovací vize Anthropic modelů (2576 px) →
 * maximální čitelnost textu na husté účtence/faktuře; menší už zhoršuje OCR.
 * Ne-obrázky (PDF apod.) i malé obrázky vrací beze změny.
 */
export async function zmensitObrazek(file, maxRozmer = 2560, kvalita = 0.9) {
    if (!file?.type?.startsWith('image/') || file.type === 'image/gif') return file;
    try {
        const bitmap = await createImageBitmap(file);
        const scale = Math.min(1, maxRozmer / Math.max(bitmap.width, bitmap.height));
        if (scale >= 1 && file.size <= 1_500_000) { bitmap.close?.(); return file; }
        const w = Math.round(bitmap.width * scale);
        const h = Math.round(bitmap.height * scale);
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(bitmap, 0, 0, w, h);
        bitmap.close?.();
        const blob = await new Promise(res => canvas.toBlob(res, 'image/jpeg', kvalita));
        if (!blob || blob.size >= file.size) return file; // nezhoršuj
        return new File([blob], file.name.replace(/\.\w+$/, '') + '.jpg',
            { type: 'image/jpeg', lastModified: file.lastModified });
    } catch {
        return file; // fallback — pošli originál
    }
}
